import { TableCell, TableRow } from '@/components/ui/table';
import { Skeleton } from '@/components/ui/skeleton';

export function TableSkeleton() {
  return (
    <div className='w-full px-8 overflow-x-auto'>
      <div className='min-w-full table'>
        {Array.from({ length: 14 }).map((_, index) => (
          <TableRow
            key={index}
            className='h-16 border-t border-zinc-800 w-full table-row'
          >
            <TableCell className='py-4 whitespace-nowrap'>
              <Skeleton className='h-4 w-24 bg-zinc-800' />
            </TableCell>
            <TableCell className='whitespace-nowrap'>
              <div className='space-y-2'>
                <Skeleton className='h-4 w-32 bg-zinc-800' />
                <Skeleton className='h-4 w-24 bg-zinc-800' />
              </div>
            </TableCell>
            <TableCell className='whitespace-nowrap'>
              <Skeleton className='h-4 w-32 bg-zinc-800' />
            </TableCell>
            <TableCell className='whitespace-nowrap'>
              <div className='flex items-center gap-2'>
                <Skeleton className='h-6 w-6 rounded-full bg-zinc-800' />
                <Skeleton className='h-4 w-24 bg-zinc-800' />
              </div>
            </TableCell>
            <TableCell className='whitespace-nowrap'>
              <Skeleton className='h-4 w-20 bg-zinc-800' />
            </TableCell>
            <TableCell className='whitespace-nowrap'>
              <Skeleton className='h-6 w-24 bg-zinc-800 rounded-full' />
            </TableCell>
          </TableRow>
        ))}
      </div>
    </div>
  );
}
